import { createContext } from 'react';
import { UserAppContextType } from './types';

export const UserAppContext = createContext<UserAppContextType>({} as UserAppContextType);
